import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-logo">Masigo</h3>
            <p className="footer-tagline">Authentic Korean Cuisine</p>
          </div>
          
          <div className="footer-info">
            <p className="footer-text">29 Chapel Market, London N1 9EN</p>
            <p className="footer-text">
              <a href="tel:+442079163212" className="footer-link">020 7837 2833</a>
            </p>
          </div>

          <div className="footer-hours">
            <p className="footer-text">Tue–Fri: 12PM–3PM, 5:30PM–10PM</p>
            <p className="footer-text">Sat: 12PM–10PM | Sun: 12PM–9PM</p>
            <p className="footer-text">Monday: Closed</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">© 2025 Masigo Korean Restaurant. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
